import { useEffect, useRef, useState } from 'react';

export default function CtaSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative py-32 md:py-40 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.helloreaddy.io/project_files/79c1f631-1cb7-456b-a6cf-fdd8ff21e9a0/a19b644c-68cf-4ce7-95a9-906d45987c79_compressed_G_Image_6655l56655l56655.webp"
          alt="加入鳴箏"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a1410]/60 via-[#1a1410]/50 to-[#1a1410]/70"></div>
      </div>

      <div className={`relative z-10 w-full px-6 md:px-12 lg:px-20 flex flex-col items-center text-center transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="flex items-center justify-center gap-3 mb-7">
          <div className="w-8 h-px bg-[#c8b89a]/50"></div>
          <span className="text-[0.8125rem] tracking-[0.2em] text-[#c8b89a]/80 font-medium uppercase">Start Here</span>
          <div className="w-8 h-px bg-[#c8b89a]/50"></div>
        </div>

        <h2
          className="font-serif-tc text-white leading-[1.35] mb-6 max-w-2xl"
          style={{ fontSize: 'clamp(1.75rem, 4vw, 2.75rem)' }}
        >
          不急著報名，<br />先確認適不適合
        </h2>

        <p className="text-[1.1875rem] leading-[1.75] text-white/70 max-w-lg mb-10">
          加入 LINE@ 不等於報名。你可以先聊聊你的狀態，問問任何問題。如果聊完覺得不適合，也可以停在那裡——這是一個安全的開始。
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <a
            href="https://line.me"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 rounded-full bg-white text-[#3a2e22] text-[1rem] font-medium hover:bg-[#f5f0e8] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            加入 LINE@ 諮詢
          </a>
          <a
            href="https://line.me"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 rounded-full border border-white/40 text-white text-[1rem] font-medium hover:border-white/70 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            先問問看，再決定也可以
          </a>
        </div>

        <p className="mt-8 text-[1rem] text-white/40">不強迫成交・不催促報名・尊重你的步調</p>
      </div>
    </section>
  );
}
